// extracted by css-extract-rspack-plugin
var _1 = "o2VlC";
export { _1 as "menuItem" }
